import { Injectable } from "@angular/core";
import { IonicErrorHandler, App } from "ionic-angular";

@Injectable()
export class AppErrorHandler implements IonicErrorHandler {
  constructor(protected app: App) {}

  handleError(err: any): void {
    console.error("Erreur : ", err);
    this.app.getActiveNavs()[0].push("ErrorPage", { error: err });
  }
}



// WEBPACK FOOTER //
// ./src/providers/error/app-error-handler.ts